import React, { memo, useEffect, useMemo, useState } from "react";
import { getAdminsByRole } from "actions/admin/actions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Card, Collapse } from "react-bootstrap";
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Owner from "./Owner";
import NewOwner from "./NewOwner";

// eslint-disable-next-line react/display-name
const Owners = memo(({
                       activeOwners = [],
                       getAdminsByRole,
                       onChange
                     }) => {
  const activeOwnersList = useMemo(() => (
      Array.isArray(activeOwners) ? activeOwners : []),
    [activeOwners]);
  const activeOwnersIdList = activeOwnersList.map(({ id }) => id);

  const [allPossibleOwners, setAllPossibleOwners] = useState([]);
  const [isOpen, setIsOpen] = useState(activeOwnersIdList.length > 0);

  useEffect(() => {
    getAdminsByRole("ROLE_PARTNER", setAllPossibleOwners);
  }, [getAdminsByRole]);

  const handleChange = (value) => {
    onChange([...activeOwnersList.filter(owner => owner.id !== value.id), {
      ...value,
      percent: Number(value.percent),
    }]);
  };

  return (
    <Card className="w-100 mb-2 rounded-0">
      <Card.Header onClick={() => setIsOpen(!isOpen)} style={{ cursor: "pointer" }}>
        Owners <FontAwesomeIcon icon={isOpen ? faArrowUp : faArrowDown}/>
      </Card.Header>
      <Collapse in={isOpen} className="p-3" timeout={0}>
        <Card.Body>
          <div>
            {activeOwnersList.sort((a, b) => a.fullname > b.fullname ? 1 : -1).map((currentOwner) => (
              <Owner
                key={currentOwner.id}
                availableOwner={currentOwner}
                handleChange={handleChange}
              />
            ))}

            <NewOwner
              allPossibleOwners={allPossibleOwners.filter(possibleOwner => !activeOwnersIdList.includes(possibleOwner.id))}
              handleChange={handleChange}
            />
          </div>
        </Card.Body>
      </Collapse>
    </Card>
  );
});

const mapStateToDispatch = dispatch => ({
  getAdminsByRole: bindActionCreators(getAdminsByRole, dispatch),
});

export default connect(
  null,
  mapStateToDispatch
)(Owners);



// WEBPACK FOOTER //
// ./src/views/pages/chargers/stations/Owners.js